import WomanProfileDetails from "../../../../Components/WomanProfileDetails/WomanProfileDetails";
import { useTranslation } from "../../../../i18n/LanguageProvider";
import Title from "../Title/Title";
import "./MonthlyWoman.sass";

function MonthlyWoman({ woman }) {
    const { t } = useTranslation();

    if (!woman) return null;

    return (
        <section className="monthly-woman" aria-labelledby="monthly-woman-title">
            <Title id="monthly-woman-title" text={t("home.monthlyTitle")} />
            <WomanProfileDetails woman={woman} className="monthly-woman__profile" nameHeadingLevel="h3" />
        </section>
    );
}

export default MonthlyWoman;
